import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../core/store";
import { LayoutReducerType } from "./reducers";

const layoutReducer = (state: RootState): LayoutReducerType => state.layoutReducer;

export const layoutStepsSelector = createSelector(layoutReducer, (state) => {
	return state.steps;
});

export const layoutEndStepSelector = createSelector(layoutReducer, (state) => state.endSteps);

export const layoutHigherIndexStepSelector = createSelector(layoutReducer, (state) => {
	let index: number | undefined = undefined;

	if (state.higherStep && state.higherStep)
		index = state.steps?.map((s) => s.id).indexOf(state.higherStep?.id);

	return index || 0;
});

export const layoutCurrentPraticaStateSelector = createSelector(
	layoutReducer,
	(state) => state.currentPraticaState
);
